import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Flex, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'
import BootstrapDataContext from '../../../context/BootstrapDataContext'

const FlexContainer = ({ className, children, ...rest }) => {
  const { isMobile = false } = useContext(BootstrapDataContext)
  return (
    <Flex
      className={className}
      isMobile={isMobile}
      m={0}
      role="option"
      width={1}
      {...rest}
    >
      {children}
    </Flex>
  )
}

const DropdownItem = styled(FlexContainer)`
  background-color: ${props =>
    props.isHighlighted ? getPaletteColor('primary.base') : null};
  color: ${props =>
    props.isHighlighted ? getPaletteColor('text.lightest') : null};
  svg {
    color: ${props =>
      props.isHighlighted ? getPaletteColor('text.lightest') : null};
  }

  cursor: pointer;
  align-items: center;

  &:hover {
    background-color: ${props =>
      props.isMobile ? null : getPaletteColor('primary.base')};
    color: ${props =>
      props.isMobile ? null : getPaletteColor('text.lightest')};
    svg {
      color: ${props =>
        props.isMobile ? null : getPaletteColor('text.lightest')};
    }
  }

  &:focus {
    background-color: ${getPaletteColor('primary.base')};
    color: ${getPaletteColor('text.lightest')};
    svg {
      color: ${getPaletteColor('text.lightest')};
    }
  }
`

FlexContainer.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
}

export default DropdownItem
